import { getCachedEnvConfig } from './services/envConfig';
/**
 * Legacy name used by components/library: read a value from cached `env.json`
 * (after `loadEnvConfig()` has run — see `index.tsx`).
 */
export function getEnvVariable(key) {
    const env = getCachedEnvConfig();
    if (!env)
        return undefined;
    return env[key];
}
